module.exports = __webpack_public_path__ + "img/upper-footer-bg.5d448814.png";